module.exports = {
  ENV_HOST: {
    CL: 'https://localhost:3000',
    PE: 'https://localhost:3000',
    CO: 'https://localhost:3000',
    AR: 'https://localhost:3000',
  },
};
